<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
  <div class="sticky top-0 z-10 bg-white dark:bg-coal-500 mb-1">
    <div class="flex flex-row">
      <label
        class="block text-2sm font-medium mb-1 text-gray-900 dark:text-gray-300"
        [for]="fields.fieldName"
      >
        {{ fields.displayName }}
      </label>
    </div>
    <div class="flex search-wrapper rounded">
      <label class="input input-sm">
        <i class="ki-filled ki-magnifier"> </i>
        <input
          searchInput
          type="text"
          #searchInput
          (input)="onKeyUpSearch(searchInput.value)"
          class="w-full text-2sm p-2"
          [placeholder]="fields.placeholder"
        />
        <button
          *ngIf="searchInput.value"
          type="button"
          class="clear-btn text-xl"
          (click)="searchInput.value = ''; onKeyUpSearch('')"
        >
          ×
        </button>
      </label>
    </div>
  </div>
  <div class="mt-4 h-300px overflow-y-auto" (scroll)="onScroll($event)">
    <!-- ✅ SKELETON -->
    <div class="user-skeleton-list" *ngIf="isLoading">
      <div class="user-skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5]">
        <div class="avatar shimmer-item bg-gray-300 dark:bg-coal-700"></div>

        <div class="details">
          <div class="name shimmer-item bg-gray-300 dark:bg-coal-700"></div>
          <div class="email shimmer-item bg-gray-300 dark:bg-coal-700"></div>
        </div>

        <div class="radio shimmer-item bg-gray-300 dark:bg-coal-700"></div>
      </div>
    </div>
    <ng-container *ngIf="fieldsData.length === 0 && !isLoading">
      <div class="flex justify-center items-center h-full w-full py-10">
        <div class="flex justify-center items-center flex-col text-center">
          <i
            class="ki-filled ki-magnifier text-3xl text-gray-500 mb-3"
            *ngIf="searchInput.value"
          ></i>

          <span
            class="text-md font-semibold text-gray-900 dark:text-gray-200 card-title mb-1"
          >
            {{ searchInput.value ? "No results found" : "No data found" }}
          </span>
          <span class="text-xs text-gray-500 max-w-[250px]">
            <!-- {{
              searchInput.value
                ? "We couldn't find any results matching \"" +
                  searchInput.value +
                  '"'
                : "There is no data to show you right now."
            }} -->

            "There is no data to show you right now."
          </span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="fieldsData.length > 0 && !isLoading">
      <div *ngFor="let option of fieldsData; let i = index">
        <label
          class="user-row flex items-center cursor-pointer rounded-md p-2"
        >
          <div class="flex items-center" [ngSwitch]="option.status">
            <div *ngSwitchCase="'ACTIVE'">
              <input
                class="radio cursor-pointer"
                type="radio"
                [formControlName]="fields.fieldName"
                [value]="{
                  email: option.email,
                  name: option.name,
                  _id: option._id,
                  profilePhoto: option.profilePhoto,
                }"
              />
            </div>

            <div *ngSwitchCase="'IN-ACTIVE'">
              <button
                (click)="$event.stopPropagation(); inviteUser(option)"
                class="btn btn-primary btn-sm text-white rounded-md font-medium text-sm hover:bg-blue-600"
              >
                <div class="loader" *ngIf="userLoading[option._id]"></div>
                Invite
              </button>
            </div>

            <div *ngSwitchDefault class="text-gray-400 text-sm">Unknown</div>
          </div>

          <!-- Profile & Info -->
          <div class="flex items-center gap-2 ms-3" *ngIf="option.name">
            <img
              [src]="getAssigneePhotoUrl(option)"
              (error)="handleImageError($event)"
              alt="Profile Photo"
              class="user-avatar w-7 h-7 rounded-full object-cover"
            />

            <div class="flex flex-col">
              <span class="user-name font-semibold text-sm">
                {{ option.name }}
              </span>
              <span *ngIf="option.email" class="user-email text-2sm">
                {{ option.email }}
              </span>
            </div>
          </div>
          <div class="flex items-center gap-2 ms-3" *ngIf="option.platformName">
            <div class="border boder-gray-300 rounded">
              <div class="ms-auto">
                <span class="user-name font-semibold text-md">
                  {{ option.platformName }}
                </span>
              </div>
              <div class="me-auto">
                <span
                  [ngClass]="{
                    'badge-success': option.status == 'Connected',
                    'badge-secondary': option.status == 'Disconnected',
                  }"
                  class="h-30px text-nowrap custom-badge badge badge-sm w-[150px] badge-outline rounded-md"
                >
                  {{ option.status }}
                </span>
              </div>
            </div>
          </div>
        </label>
      </div>
    </ng-container>
    <div class="flex justify-center py-2" *ngIf="isLoadingMore">
      <div class="loader"></div>
    </div>
  </div>
  <div *ngIf="showError" class="text-danger text-sm mt-1">
    Please select user
  </div>
</div>
